// extracted by mini-css-extract-plugin
export var newsBox = "NewsBox-module--newsBox--kmmND";
export var newsBox__headline = "NewsBox-module--newsBox__headline--ublhD";
export var newsBox__content = "NewsBox-module--newsBox__content--cyOgE";
export var newsBox__more = "NewsBox-module--newsBox__more--YMSr4";
export var newsBox_navigationPage = "NewsBox-module--newsBox_navigationPage--QEcUs";
export var newsBoxItem = "NewsBox-module--newsBoxItem--Lgfkf";
export var newsBoxItem__header = "NewsBox-module--newsBoxItem__header--135aC";